"use client";

import Link from "next/link";
import { ArrowLeft, Calculator, LayoutDashboard } from "lucide-react";

interface ReportReturnActionsProps {
  analysisHref: string;
  dashboardHref: string;
  title?: string;
  description?: string;
}

export function ReportReturnActions({
  analysisHref,
  dashboardHref,
  title = "리포트 저장 후 바로 이어가기",
  description = "저장된 결과는 손익 계산 기록에서 다시 열 수 있고, 사건 검토 화면으로 바로 돌아갈 수 있습니다.",
}: ReportReturnActionsProps) {
  return (
    <div className="w-full max-w-[364mm] mx-auto mb-3 sm:mb-4 md:mb-6 rounded-lg border border-slate-200 bg-white p-3 sm:p-4 shadow-sm dark:border-slate-800 dark:bg-slate-900 print:hidden">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <p className="text-sm font-semibold text-slate-900 dark:text-slate-100">
            {title}
          </p>
          <p className="mt-1 text-xs text-slate-500 dark:text-slate-400">
            {description}
          </p>
        </div>
        <div className="flex flex-wrap gap-2">
          <Link
            href={dashboardHref}
            className="inline-flex items-center gap-2 rounded-lg border border-slate-200 px-3 py-2 text-sm font-medium text-slate-700 transition-colors hover:bg-slate-50 dark:border-slate-700 dark:text-slate-200 dark:hover:bg-slate-800"
          >
            <Calculator className="h-4 w-4" />
            손익 계산 기록
          </Link>
          <Link
            href={analysisHref}
            className="inline-flex items-center gap-2 rounded-lg bg-slate-900 px-3 py-2 text-sm font-medium text-white transition-colors hover:bg-slate-800 dark:bg-slate-100 dark:text-slate-900 dark:hover:bg-slate-200"
          >
            <ArrowLeft className="h-4 w-4" />
            사건 검토로 돌아가기
          </Link>
          <Link
            href="/dashboard"
            className="inline-flex items-center gap-2 rounded-lg border border-slate-200 px-3 py-2 text-sm font-medium text-slate-700 transition-colors hover:bg-slate-50 dark:border-slate-700 dark:text-slate-200 dark:hover:bg-slate-800"
          >
            <LayoutDashboard className="h-4 w-4" />
            검토 상황판
          </Link>
        </div>
      </div>
    </div>
  );
}
